const pricingIframeMessageSources = new Map();

export function resolvePricingIframeOrigin(url = "") {
	const rawUrl = typeof url === "string" ? url.trim() : "";
	if (!rawUrl) {
		return "";
	}

	try {
		const baseUrl = typeof window !== "undefined" && window.location && window.location.href
			? window.location.href
			: "https://localhost/";
		const origin = new URL(rawUrl, baseUrl).origin;
		return origin && origin !== "null" ? origin : "";
	} catch (_err) {
		return "";
	}
}

function getIframeWindow(iframe = null) {
	return iframe && iframe.contentWindow ? iframe.contentWindow : iframe;
}

export function isMessageFromPricingIframe(event, iframe, url = "") {
	const source = getIframeWindow(iframe);
	const origin = resolvePricingIframeOrigin(url);
	return Boolean(
		event
		&& source
		&& origin
		&& event.source === source
		&& event.origin === origin
	);
}

export function registerPricingIframeMessageSource(owner, iframe, url = "", sessionId = "") {
	if (!owner) {
		return false;
	}

	const source = getIframeWindow(iframe);
	const origin = resolvePricingIframeOrigin(url);
	const normalizedSessionId = typeof sessionId === "string" ? sessionId.trim() : "";
	if (!source || !origin) {
		pricingIframeMessageSources.delete(owner);
		return false;
	}

	const previousEntry = pricingIframeMessageSources.get(owner);
	const sameRegistration = previousEntry
		&& previousEntry.source === source
		&& previousEntry.origin === origin
		&& previousEntry.sessionId === normalizedSessionId;
	pricingIframeMessageSources.set(owner, {
		source,
		origin,
		sessionId: normalizedSessionId,
		initialized: sameRegistration ? previousEntry.initialized : false,
		tokenRequired: sameRegistration ? previousEntry.tokenRequired : false
	});
	return true;
}

export function markPricingIframeMessageSourceInitialized(owner, sessionId = "") {
	const entry = owner ? pricingIframeMessageSources.get(owner) : null;
	const normalizedSessionId = typeof sessionId === "string" ? sessionId.trim() : "";
	if (!entry || entry.sessionId !== normalizedSessionId) {
		return false;
	}
	entry.initialized = true;
	return true;
}

export function unregisterPricingIframeMessageSource(owner) {
	if (owner) {
		pricingIframeMessageSources.delete(owner);
	}
}

export function isRegisteredPricingIframeMessage(event) {
	return Boolean(getRegisteredPricingIframeMessageContext(event));
}

export function getRegisteredPricingIframeMessageContext(event) {
	if (!event || !event.source || !event.origin) {
		return null;
	}

	for (const [owner, entry] of pricingIframeMessageSources.entries()) {
		if (entry.source === event.source && entry.origin === event.origin) {
			return { owner, ...entry };
		}
	}

	return null;
}

export function isPricingIframeMessageForSession(event, sessionId = "", messageSessionId = "") {
	const entry = getRegisteredPricingIframeMessageContext(event);
	const normalizedSessionId = typeof sessionId === "string" ? sessionId.trim() : "";
	const normalizedMessageSessionId = typeof messageSessionId === "string" ? messageSessionId.trim() : "";
	if (!entry || !normalizedSessionId || entry.sessionId !== normalizedSessionId || !entry.initialized) {
		return false;
	}

	if (normalizedMessageSessionId) {
		if (normalizedMessageSessionId !== normalizedSessionId) {
			return false;
		}
		const registeredEntry = pricingIframeMessageSources.get(entry.owner);
		if (registeredEntry) {
			registeredEntry.tokenRequired = true;
		}
		return true;
	}

	return !entry.tokenRequired;
}
